<div class="header">
  <button (click)="cancel()" class="popup-close-button" tabindex="0"></button>
  <h2 class="title">{{ (isNew ? 'WORK_SCHEDULE.Add_Entry' : 'WORK_SCHEDULE.Edit_Entry') | translate }}</h2>
</div>

<div class="body">
  <form [formGroup]="entryForm">
    <!-- Entry Type Selector -->
    <div class="form-row">
      <label>{{ 'WORK_SCHEDULE.Entry_Type' | translate }}</label>
      <select class="select-styled" [(ngModel)]="entryType" [ngModelOptions]="{standalone: true}" (change)="onEntryTypeChange()">
        <option [ngValue]="WorkScheduleEntryType.Day_Of_Week" *ngIf="isEntryTypeAllowed(WorkScheduleEntryType.Day_Of_Week)">{{ 'WORK_SCHEDULE.Day_Of_Week' | translate }}</option>
        <option [ngValue]="WorkScheduleEntryType.Specific_Date" *ngIf="isEntryTypeAllowed(WorkScheduleEntryType.Specific_Date)">{{ 'WORK_SCHEDULE.Specific_Date' | translate }}</option>
        <option [ngValue]="WorkScheduleEntryType.Relative_Date" *ngIf="isEntryTypeAllowed(WorkScheduleEntryType.Relative_Date)">{{ 'WORK_SCHEDULE.US_Holidays' | translate }}</option>
      </select>
    </div>

    <!-- Day of Week Fields (Multi-select checkboxes) -->
    <div class="form-row days-of-week-row" *ngIf="entryType === WorkScheduleEntryType.Day_Of_Week">
      <label>{{ 'WORK_SCHEDULE.Day' | translate }}<span class="required">*</span></label>
      <div class="days-checkbox-group">
        <label *ngFor="let day of daysOfWeek" class="day-checkbox">
          <input type="checkbox"
                 [checked]="selectedDays.has(day.value)"
                 (change)="toggleDay(day.value)">
          <span class="day-label">{{ day.label | translate }}</span>
        </label>
      </div>
      <div class="quick-select-buttons">
        <button type="button" class="quick-select-btn" (click)="selectWeekdays()">{{ 'WORK_SCHEDULE.Weekdays' | translate }}</button>
        <button type="button" class="quick-select-btn" (click)="selectWeekend()">{{ 'WORK_SCHEDULE.Weekend' | translate }}</button>
        <button type="button" class="quick-select-btn" (click)="selectAll()">{{ 'WORK_SCHEDULE.All_Days' | translate }}</button>
        <button type="button" class="quick-select-btn" (click)="clearDays()">{{ 'WORK_SCHEDULE.Clear' | translate }}</button>
      </div>
      <div class="checkbox-row-inline day-options">
        <label class="checkbox-label">
          <input type="checkbox" formControlName="entireDay" >
          {{ 'WORK_SCHEDULE.Entire_Day' | translate }}
        </label>
      </div>
    </div>

    <!-- Effective Date Range (for day_of_week entries) -->
    <div *ngIf="entryType === WorkScheduleEntryType.Day_Of_Week">
      <div class="form-row">
        <label>{{ 'WORK_SCHEDULE.Effective_Date' | translate }}</label>
        <input type="date" class="input-styled" formControlName="effectiveDate" [attr.min]="isAdmin ? null : todayDate">
        <span class="hint">{{ 'WORK_SCHEDULE.Effective_Date_Hint' | translate }}</span>
      </div>

      <div class="form-row">
        <label>{{ 'WORK_SCHEDULE.Expires_Date' | translate }}</label>
        <input type="date" class="input-styled" formControlName="expiresDate" [attr.min]="entryForm.value.effectiveDate || todayDate">
        <span class="hint">{{ 'WORK_SCHEDULE.Expires_Date_Hint' | translate }}</span>
      </div>

      <div class="form-row full-width">
        <label>{{ 'WORK_SCHEDULE.Notes' | translate }}</label>
        <textarea class="input-styled notes-textarea" formControlName="notes" rows="2" placeholder="{{ 'WORK_SCHEDULE.Notes_Placeholder' | translate }}"></textarea>
      </div>
    </div>

    <!-- Date Range Fields -->
    <div *ngIf="entryType === WorkScheduleEntryType.Specific_Date">
      <div class="form-row">
        <label>{{ 'WORK_SCHEDULE.Start_Date' | translate }}<span class="required">*</span></label>
        <input type="date" class="input-styled" formControlName="startDate" [attr.min]="minDate">
      </div>

      <div class="form-row">
        <label>{{ 'WORK_SCHEDULE.End_Date' | translate }}</label>
        <input type="date" class="input-styled" formControlName="endDate" [attr.min]="minDate">
        <span class="hint">{{ 'WORK_SCHEDULE.End_Date_Hint' | translate }}</span>
      </div>

      <div class="form-row full-width">
        <label>{{ 'WORK_SCHEDULE.Notes' | translate }}</label>
        <textarea class="input-styled notes-textarea" formControlName="notes" rows="2" placeholder="{{ 'WORK_SCHEDULE.Notes_Placeholder' | translate }}"></textarea>
      </div>

      <div class="form-row checkbox-row-inline">
        <label class="checkbox-label">
          <input type="checkbox" formControlName="repeatAnnually">
          {{ 'WORK_SCHEDULE.Repeat_Annually' | translate }}
        </label>
        <label class="checkbox-label">
          <input type="checkbox" formControlName="entireDay" >
          {{ 'WORK_SCHEDULE.Entire_Day' | translate }}
        </label>
      </div>
    </div>

    <!-- US Holidays Fields -->
    <div *ngIf="entryType === WorkScheduleEntryType.Relative_Date">
      <div class="form-row">
        <label>{{ 'WORK_SCHEDULE.Holiday' | translate }}<span class="required">*</span></label>
        <select class="select-styled" formControlName="relativeDayName">
          <option value="">{{ 'WORK_SCHEDULE.Select_Holiday' | translate }}</option>
          <option *ngFor="let holiday of usHolidays" [value]="holiday.value">{{ holiday.label | translate }}</option>
        </select>
      </div>

      <div class="form-row">
        <label>{{ 'WORK_SCHEDULE.Day_Offset' | translate }}</label>
        <input type="number" class="input-styled" formControlName="relativeDayOffset" placeholder="0">
        <span class="hint">{{ 'WORK_SCHEDULE.Day_Offset_Hint' | translate }}</span>
      </div>

      <div class="form-row">
        <label>{{ 'WORK_SCHEDULE.Effective_Date' | translate }}</label>
        <input type="date" class="input-styled" formControlName="effectiveDate" [attr.min]="isAdmin ? null : todayDate">
        <span class="hint">{{ 'WORK_SCHEDULE.Effective_Date_Hint' | translate }}</span>
      </div>

      <div class="form-row">
        <label>{{ 'WORK_SCHEDULE.Expires_Date' | translate }}</label>
        <input type="date" class="input-styled" formControlName="expiresDate" [attr.min]="entryForm.value.effectiveDate || todayDate">
        <span class="hint">{{ 'WORK_SCHEDULE.Expires_Date_Hint' | translate }}</span>
      </div>

      <div class="form-row full-width">
        <label>{{ 'WORK_SCHEDULE.Notes' | translate }}</label>
        <textarea class="input-styled notes-textarea" formControlName="notes" rows="2" placeholder="{{ 'WORK_SCHEDULE.Notes_Placeholder' | translate }}"></textarea>
      </div>

      <div class="form-row checkbox-row-inline">
        <label class="checkbox-label">
          <input type="checkbox" formControlName="repeatAnnually">
          {{ 'WORK_SCHEDULE.Repeat_Annually' | translate }}
        </label>
        <label class="checkbox-label">
          <input type="checkbox" formControlName="entireDay" >
          {{ 'WORK_SCHEDULE.Entire_Day' | translate }}
        </label>
      </div>
    </div>

    <!-- Time Fields (common to all types, hidden when Entire Day is checked) -->
    <div class="time-section" *ngIf="!entryForm.get('entireDay').value">
      <div class="form-row">
        <label>{{ 'WORK_SCHEDULE.Start_Time' | translate }}<span class="required">*</span></label>
        <input type="time" class="input-styled" formControlName="startTime">
      </div>

      <div class="form-row">
        <label>{{ 'WORK_SCHEDULE.End_Time' | translate }}<span class="required">*</span></label>
        <input type="time" class="input-styled" formControlName="endTime">
      </div>
    </div>
  </form>
</div>

<div class="button-block">
  <ion-button (click)="cancel()" class="page-button" color="light">{{ 'SHARED.Cancel' | translate }}</ion-button>
  <ion-button (click)="saveAndAddAnother()" class="page-button" color="tertiary" [disabled]="!isFormValid()" *ngIf="isNew">{{ 'WORK_SCHEDULE.Save_And_Add_Another' | translate }}</ion-button>
  <ion-button (click)="save()" class="page-button" color="secondary" [disabled]="!isFormValid()">{{ 'SHARED.Save' | translate }}</ion-button>
</div>
